import { getWithToken, postWithToken, putWithToken } from './http-client';

export default {
  async getProductsByTypeVoucherId(idType, token) {
    return getWithToken(`${process.env.REACT_APP_API_VOUCHERS}/Producto/tipoVoucher/${idType}`, token)
      .then((res) => res.data)
      .catch((err) => err);
  },
  async getVoucherOfertas(token) {
    return getWithToken(`${process.env.REACT_APP_API_VOUCHERS}/Voucher/voucherOferta/`, token)
      .then((res) => res.data)
      .catch((err) => err);
  },
  async getVouchers(token) {
    return getWithToken(`${process.env.REACT_APP_API_VOUCHERS}/Voucher/voucherOferta/`, token)
      .then((res) => res.data)
      .catch((err) => err);
  },
  async getAdditionalInfoByProductoId(idProduct, token) {
    return getWithToken(`${process.env.REACT_APP_API_VOUCHERS}/Producto/productoInfoAdiciona/${idProduct}`, token)
      .then((res) => res.data)
      .catch((err) => err);
  },
  async buy(data, token) {
    return postWithToken(`${process.env.REACT_APP_API_VOUCHERS}/Compra/`, data, token)
      .then((res) => res)
      .catch((err) => err);
  },
  async confirmPayment(id, token) {
    return putWithToken(`${process.env.REACT_APP_API_VOUCHERS}/Compra/pago/${id}`, null, token)
      .then((res) => res.data)
      .catch((err) => err);
  },
};
